import React from 'react';

const SafeIcon = ({ icon: Icon, className = '', style = {}, ...props }) => {
  if (!Icon || typeof Icon !== 'function') return null;
  try {
    return <Icon className={className} style={style} {...props} />;
  } catch {
    return null;
  }
};

export default SafeIcon;